import {
  parseLocalDatetimeStringToZonedDate,
  formatTzDate,
} from 'Data/format.js'

/**
 *
 * @param {{ start: string, end: string }} event
 * @param {string} timeZoneId
 * @returns {string}
 */
export function formatTime({ startStr, endStr }, timeZoneId) {
  let dateStart = parseLocalDatetimeStringToZonedDate(startStr, timeZoneId)
  let dateEnd = parseLocalDatetimeStringToZonedDate(endStr, timeZoneId)

  return `${formatTzDate(
    dateStart,
    'd MMMM, yyyy, hh:mm',
    timeZoneId
  )} - ${formatTzDate(dateEnd, 'hh:mm a', timeZoneId)}`
}
